import React from 'react';
import { Button, Box, Text } from '@chakra-ui/react';
import type { SidebarNode } from './navigationDefinitions';

export const SidebarItem = React.memo(function SidebarItem({
  to,
  label,
  icon: IconCmp,
  collapsed,
  onNavigate,
}: {
  to?: string;
  label: string;
  icon: React.ElementType;
  collapsed: boolean;
  onNavigate: (path: string) => void;
}): JSX.Element {
  const handleClick = () => {
    if (!to) return;
    // Check if external URL (starts with http/https)
    if (to.startsWith('http://') || to.startsWith('https://')) {
      window.open(to, '_blank', 'noopener,noreferrer');
    } else {
      onNavigate(to);
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant="ghost"
      px={2}
      py={2}
      borderRadius="md"
      _hover={{ bg: 'gray.50' }}
      display="flex"
      alignItems="center"
      gap={3}
      justifyContent={collapsed ? 'center' : 'flex-start'}
      w="full"
    >
      <Box as={IconCmp} />
      {!collapsed && <Text>{label}</Text>}
    </Button>
  );
});

export type { SidebarNode };
